/* eslint-disable no-debugger */
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  isError: false,
  error: '',
  isCampaignError: false,
  errorCampaignMsg: '',
  isSuccess: false,
  success: '',
  successNewRule: '',
  isCampaignSuccess: false,
  status: true,
  campaignRulesSetData: [],
  particularCampaignRuleData: {},
  newId: null
};

const slice = createSlice({
  name: 'campaignrules',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    resetCapmpaignFileError(state) {
      state.error = '';
    },
    resetSuccess(state) {
      state.success = '';
      state.successNewRule = '';
      state.isCampaignSuccess = false;
      state.isSuccess = false;
    },
    resetError(state) {
      state.error = '';
      state.isError = false;
      // state.isCampaignError = false;
      // state.errorCampaignMsg = '';
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.isLoading = false;
      state.error = message;
      // state.errorCampaignMsg = action.payload;
      // state.isCampaignError = true;
      state.isError = true;
    },
    // GET MASTER_FILE
    getCampaignRuleDataSuccess(state, action) {
      state.isLoading = false;
      state.campaignRulesSetData = action.payload;
    },
    // CREATE MASTER_FILE
    createNewCampaignRuleSucess(state, action) {
      const newCampaignRuleData = action.payload;
      state.isLoading = false;
      // state.campaignRulesSetData = [...state.campaignRulesSetData, newCampaignRuleData];
      state.isSuccess = true;
      state.success = 'New Rule Added Successfully';
      state.isCampaignSuccess = true;
      state.successNewRule = 'New Rule Added Successfully';
    },
    // DELETE_MASTER_FILE
    deleteCampaignRuleSuccess(state, action) {
      // const { message } = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.success = 'Deleted Successfully';
    },
    // UPDATE_MASTER_FILE
    updateCampaignRuleSuccess(state, action) {
      // const campaignRule = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.success = 'Updated Successfully';
      // state.campaignRulesSetData = updateCampaignRule;
    },
    // UPDATE CAMPAIGN PARENT RULE NAME
    updateCampaignParentRuleSuccess(state, action) {
      state.isSuccess = true;
      state.success = 'Updated Successfully';
      state.isLoading = false;
      // state.campaignRulesSetData = updateCampaignRule;
    },
    // get Particular Campaign Data
    getParticularCampaignRuleSuccess(state, action) {
      state.isLoading = false;
      state.particularCampaignRuleData = { ...state.particularCampaignRuleData, [action.payload.id]: action.payload };
    },
    // add more Rules locally
    addParticularCampaignRuleSuccess(state, action) {
      state.isLoading = false;
      const { fileObj, id, segmentName } = action.payload;
      // Object.keys(state.particularCampaignRuleData).filter(key => state.particularCampaignRuleData[key] === id);
      if (segmentName === state.particularCampaignRuleData[segmentName]) {
        state.particularCampaignRuleData = {
          ...state.particularCampaignRuleData,
          [id]: {
            ...state.particularCampaignRuleData[id],
            rules: [...state.particularCampaignRuleData[id].rules, { ...fileObj, id }]
          }
        };
      } else {
        state.particularCampaignRuleData = {
          ...state.particularCampaignRuleData,
          [id]: { segmentName, campaign_rule_name: 'new rule123', status: 'active', rules: [{ ...fileObj }] }
        };
        state.newId = id;
      }
    },
    // create new Campaign Rule Name
    createCampaignRuleParentSuccess(state, action) {
      state.isSuccess = true;
      state.success = 'Campaign Rule Set Created Successfully';
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  onToggleFollow,
  deleteUser,
  resetCapmpaignFileError,
  resetError,
  resetSuccess,
  addParticularCampaignRuleSuccess,
  createCampaignRuleParentSuccess
} = slice.actions;

// ----- get Campaign RuleSet
export function getCampaignRuleData() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: 'http://smartcollect-api.cp360apps.com/campaign-rule/campaign-rule/'
      });
      dispatch(slice.actions.getCampaignRuleDataSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----create Campaign Rule File
export function createNewCampaignRule(fileObj, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/rule-column/${id}/`,
        data: fileObj
      });
      dispatch(slice.actions.createNewCampaignRuleSucess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// --- delete Campaign Rule File

export function deleteCampaignRule(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/rule-collection-delete/${id}/`
      });
      dispatch(slice.actions.deleteCampaignRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// Update Campaign Rule
export function updateCampaignRule(CampaignRuleData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/rule-collection-edit/${id}/`,
        data: CampaignRuleData
      });
      dispatch(slice.actions.updateCampaignRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// Update CampaignParentRule
export function updateCampaignParentRule(CampaignParentRuleData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/campaign-rule/${id}/`,
        data: CampaignParentRuleData
      });
      dispatch(slice.actions.updateCampaignParentRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// get particular campaignRule data

export function getParticularCampaignRule(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/campaign-rule/${id}/`
      });
      dispatch(slice.actions.getParticularCampaignRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// add Particular CampaignRule
export function addParticularCampaignRule(fileObj, segmentName, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const segmentFileObj = { fileObj, id, segmentName };
      dispatch(slice.actions.addParticularCampaignRuleSuccess(segmentFileObj));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// create new Campaign Rule Set Parent
export function createCampaignRuleParent(campaignNameObj, rules) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/campaign-rule/`,
        data: campaignNameObj
      });
      dispatch(createCampaignRuleParentSuccess());
      dispatch(updateCampaignRuleSet(rules, response.data?.id));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function updateCampaignRuleSet(fileObj, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/campaign-rule/campaign-rule-update/${id}/`,
        data: fileObj
      });
      dispatch(slice.actions.updateCampaignRuleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}
